import { useState } from 'react'

import requestService from '@/services/request.service'

type Options = {
  /** Referrer tag Cardsphere reports back to us, e.g. `clipboard` -> `edhrec-clipboard` */
  medium: string
  /** Called with the final url just before it is opened, for outbound tracking */
  onOutbound?: (url: string) => void
}

/**
 * Cardsphere has no static bulk export url like the other vendors - the card list has to be posted
 * to our api, which hands back a one-off wishlist url to open.
 *
 * Each card is a line that may lead with a quantity, e.g. `10 Forest`, or be a bare name for a
 * single copy.
 */
const useCardsphereExport = ({ medium, onOutbound }: Options) => {
  const [isLoading, setIsLoading] = useState(false)

  const openCardsphere = async (cards: string[]) => {
    if (isLoading || cards.length === 0) return

    setIsLoading(true)
    try {
      const resp = await requestService.post('/api/cardsphere', { cards })
      const { url } = await resp.json()
      if (url) {
        const outboundUrl = `${url}&referrer=edhrec-${medium}`
        onOutbound?.(outboundUrl)
        window.open(outboundUrl, '_blank')
      }
    } finally {
      setIsLoading(false)
    }
  }

  return { isLoading, openCardsphere }
}

export default useCardsphereExport
